import { useState } from 'react';
import { useBrowserLayoutEffect } from './useBrowserLayoutEffect';
import { useBreakpoint } from './useBreakpoint';

export function useIsSmallScreen() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const breakpoint = useBreakpoint();

  useBrowserLayoutEffect(() => {
    setIsSmallScreen(['xs', 'sm', 'md'].includes(breakpoint));
  }, [breakpoint]);

  return isSmallScreen;
}
